import { ArrowRight } from "lucide-react";
import { offer, whatsappPrefill } from "@/config/site";
import { Section } from "./Section";
import { Reveal, ImageReveal } from "./Reveal";

const STEPS = [
    {
        label: "Assess",
        caption: "Inspection and wash-down on the studio floor",
        image: "/assets/work/studio-floor-2.webp",
        alt: "Real Revautoz studio floor — vehicles being assessed and detailed",
        placeholder: false,
    },
    {
        label: "Correct",
        caption: "Machine correction, panel by panel",
        image: "/assets/work/work-detailing-polish.webp",
        alt: "Real Revautoz work — machine polishing a headlight and fender",
        placeholder: false,
    },
    {
        label: "Protect",
        caption: "Film and coating lock in the result",
        image: "/assets/work/work-ppf-x5.webp",
        alt: "Real Revautoz work — paint protection film applied to a BMW X5",
        placeholder: false,
    },
];

export const DetailingTransform = () => (
    <Section id="detailing-transformation" index="08" label="Detailing" title="From neglected to refined." alt>
        <div className="mt-14 grid gap-6 lg:grid-cols-3">
            {STEPS.map((s, i) => (
                <Reveal key={s.label} delay={i * 0.08} className="relative">
                    <div className="rz-corners group overflow-hidden border border-rz-steel/60">
                        <ImageReveal>
                            <img
                                src={s.image}
                                alt={s.alt}
                                loading="lazy"
                                decoding="async"
                                className="aspect-[4/3] w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.03]"
                            />
                        </ImageReveal>
                        <div className="flex items-center justify-between border-t border-rz-steel/60 bg-rz-graphite/40 px-5 py-4">
                            <span className="font-display text-[11px] font-bold uppercase tracking-[0.22em] text-rz-red">
                                {s.label}
                            </span>
                            <span className="text-right text-[12px] text-rz-smoke">{s.caption}</span>
                        </div>
                    </div>
                    {i < STEPS.length - 1 && (
                        <ArrowRight
                            size={18}
                            className="absolute -right-4 top-1/2 z-10 hidden -translate-y-1/2 text-rz-red lg:block"
                            aria-hidden="true"
                        />
                    )}
                </Reveal>
            ))}
        </div>
        <Reveal className="mt-8 flex flex-wrap items-center justify-between gap-4" delay={0.1}>
            <p className="text-[12px] uppercase tracking-[0.18em] text-rz-smoke">
                Shot on the Revautoz studio floor
            </p>
            <a
                data-testid="detailing-transform-cta"
                href={whatsappPrefill(offer.message)}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 font-display text-[12px] font-semibold uppercase tracking-[0.2em] text-rz-red transition-transform duration-300 hover:translate-x-1"
            >
                Want this for your car? {offer.cta} →
            </a>
        </Reveal>
    </Section>
);
